export default function(element) {
  let jobElements = Array.from(element.getElementsByClassName('job'))
  let firstCard = jobElements.map((je, index) => ({
    height: je.getBoundingClientRect().height + 130,
    index,
    accountManagerId: element.id
  }))
  return firstCard
}
